import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../styles/Testimonials.scss";

import h1 from "../assets/testimonial/h1.jpg";
import h2 from "../assets/testimonial/h2.jpg";
import h3 from "../assets/testimonial/h3.jpg";
import h4 from "../assets/testimonial/h4.jpg";
import h5 from "../assets/testimonial/h5.jpg";
import h6 from "../assets/testimonial/h6.jpg";
import h7 from "../assets/testimonial/h7.jpg";
import h8 from "../assets/testimonial/h8.jpg";
import h9 from "../assets/testimonial/h9.jpg";

const images = [h1, h2, h3, h4, h5, h6, h7, h8, h9];

const item = {
  hidden: { opacity: 0, y: 30, scale: 0.9 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function Testimonials() {
  return (
    <section className="testimonials">
      {/* Desktop staggered floating layout */}
      <div className="image-layer desktop-only">
        {images.map((src, i) => (
          <motion.div
            key={i}
            className={`img-box img-${i + 1}`}
            variants={item}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <img src={src} alt={`testimonial-${i}`} />
          </motion.div>
        ))}
      </div>

      {/* Mobile Swiper */}
      <div className="mobile-only">
        <Swiper
          modules={[Pagination, Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
        >
          {images.map((src, i) => (
            <SwiperSlide key={i}>
              <motion.div
                className="img-box"
                variants={item}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <img src={src} alt={`testimonial-mobile-${i}`} />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Center Text Block */}
      <motion.div
        className="text-content"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <span className="label">Testimonials</span>
        <h2>
          Smiles of Satisfaction at Lonavalley <br />
          {/* <span className="light">from various industries</span> */}
        </h2>
        <p>
          Discover why families and investors chose Lonavalley as their second home in nature.
        </p>
        <button className="cta-btn">
          Watch Their Stories <span>→</span>
        </button>
      </motion.div>
    </section>
  );
}
